export default {
  data(){
    return {
      weeks           : [],

      calendarParams  : {
        moment  : null,
        days    : 0,
        counter : 1,
      }
    }
  },

  methods : {
    generateCalendar(month){
      let targetMonth = null;
  
      if(typeof month === 'undefined'){
        targetMonth = this.$moment().startOf('month');
      }else{
        targetMonth = month;
      }
  
      this.calendarParams = {
        moment    : targetMonth,
        days      : targetMonth.daysInMonth(),
        counter   : 1,
      }
      
      let calendar      = [];
  
      // カレンダーは最大６行です。
      for(let week = 1; week <= 6; week++){
        calendar.push( this.generateCalendarWeek(week) );
      }
      
      // ６行目が空の場合は除去します。
      if(calendar[(6 - 1)].length === 0){
        calendar = calendar.splice(0, 5);
      }
  
      return calendar;
    },
  
    generateCalendarWeek(week){
      const calendarWeek = [];
      // ７日あります。
      for(let daySlot = 0; daySlot <= 6; daySlot++){
        // 初週の場合
        if( (week === 1) && (this.calendarParams.counter === 1) ){
          const startWeekDay = this.calendarParams.moment.startOf('month').add(this.calendarParams.counter).weekday();
          if(daySlot < startWeekDay){
            calendarWeek.push(null);
          }else{
            calendarWeek.push({
              day     : this.calendarParams.counter,
              stamped : false
            });
            
            this.calendarParams.counter++;
          }
        }else if(this.calendarParams.counter <= this.calendarParams.days){
          calendarWeek.push({
            day     : this.calendarParams.counter,
            stamped : false
          });
          
          this.calendarParams.counter++;
        }else{
          if((week === 6) && (daySlot === 0)) break;
  
          calendarWeek.push(null);
        }
      }
      return calendarWeek;
    },
  
    attachStampedFlags(loginStamps){
      for(let item of loginStamps){
        for(let weekIndex = 0; weekIndex < this.weeks.length; weekIndex++){
          for(let dayIndex = 0; dayIndex < this.weeks[weekIndex].length; dayIndex++){
            if(this.weeks[weekIndex][dayIndex] === null) continue;
            if(parseInt(this.weeks[weekIndex][dayIndex].day) === this.getMomentDay(item.logined_at)){
              this.weeks[weekIndex][dayIndex].stamped = true;
            }
          }
        }
      }
    },

    getMomentDay(dayString){
      return parseInt(this.$moment(dayString).format('DD'));
    }
  }
}